module.exports = __webpack_public_path__ + "static/media/corporatesBlueIcon.072ebe26.svg";